"use strict";
import { quoteRequestTimeoutSignal } from "features/routing/api/quoteRequestTimeout";
const TOPAZ_ROUTING_API_BASE = process.env.REACT_APP_TOPAZ_ROUTING_API || "https://quote.topazdex.com";
export const TOPAZ_API_NATIVE_TOKEN = "BNB";
export const TOPAZ_API_UNIVERSAL_ROUTER = "0x691e6171e0a434FfE5C9f1759621D05b9efcF6A6";
async function parseTopazApiError(res) {
  const body = await res.json().catch(() => ({}));
  return body?.error || res.statusText;
}
export async function fetchTopazApiQuote(request, permit) {
  if (permit && !request.permitGrantedInBatch) {
    const res2 = await fetch(`${TOPAZ_ROUTING_API_BASE}/quote`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ ...request, permit }),
      signal: quoteRequestTimeoutSignal()
    });
    if (!res2.ok) {
      throw new Error(`Topaz API quote error: ${await parseTopazApiError(res2)}`);
    }
    return res2.json();
  }
  const qs = new URLSearchParams({
    tokenIn: request.tokenIn,
    tokenOut: request.tokenOut,
    amount: request.amount
  });
  if (request.type) {
    qs.set("type", request.type);
  }
  if (request.recipient) {
    qs.set("recipient", request.recipient);
  }
  if (request.slippageBips !== void 0) {
    qs.set("slippageBips", request.slippageBips.toString());
  }
  const deadlineSeconds = request.permitGrantedInBatch ? Math.min(request.deadlineSeconds ?? 1800, 1800) : request.deadlineSeconds;
  if (deadlineSeconds !== void 0) {
    qs.set("deadlineSeconds", deadlineSeconds.toString());
  }
  if (request.permitGrantedInBatch) {
    qs.set("permitGrantedInBatch", "true");
    qs.set("skipCache", "true");
  }
  const res = await fetch(`${TOPAZ_ROUTING_API_BASE}/quote?${qs.toString()}`, {
    cache: request.permitGrantedInBatch ? "no-store" : void 0,
    signal: quoteRequestTimeoutSignal()
  });
  if (!res.ok) {
    throw new Error(`Topaz API quote error: ${await parseTopazApiError(res)}`);
  }
  return res.json();
}
